import { Link } from "react-router-dom";
import UIkit from "uikit";
import "../features/features.css";

const Notification = () => {
  const closePanel = () => UIkit.offcanvas("#modal-notifications").hide();
  return (
    <div id="modal-notifications" className="uk-modal-full hms-modals uk-modal uk-open uk-dark" uk-offcanvas="flip: true; overlay: true">
      <div className="uk-offcanvas-bar hms-notifications">
        <div className="hms-modals-main">
          <button className="uk-offcanvas-close uk-close-large" type="button" data-uk-close aria-label="Close notifications" />
          <div className="uk-modal-header"><span className="uk-modal-title">Notifications</span></div>
          <div className="uk-modal-body uk-flex-column notifications">
            <p>Browse product updates and feature instructions whenever you need them.</p>
            <div className="rbr-discovery-actions">
              <Link to="/whats-new" onClick={closePanel}>What's New →</Link>
              <Link to="/features" onClick={closePanel}>Your Features →</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
